import React, { useContext } from "react";
import "./Works.css";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome-2">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>Skills For</span>
          <span className="skills-heading">
            Delivering Innovative Solutions
          </span>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img className="tools-circle react" src="/img/recct.png" alt="" />
          </div>
          <div className="w-secCircle">
            <img className="tools-circle" src="/img/html.png" alt="" />
          </div>
          <div className="w-secCircle">
            <img className="tools-circle " src="/img/canva-icon.webp" alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img className="tools-circle " src="/img/bootstrap.png" alt="" />
          </div>
          <div className="w-secCircle">
            <img className="tools-circle " src="/img/java.png" alt="" />
          </div>
          <div className="w-secCircle">
            <img className="tools-circle css" src="/img/css3.png" alt="" />
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
